import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import {FormattedMessage} from 'react-intl';
import {dateTimeFormats, POSIntegrations, POSMonths} from 'helpers/constants';

const summarySectionPosDate = ({POSActive, dealer}) => {
  return (
    <div style={{marginBottom: '15px', marginTop: '15px'}}>
      <div style={{fontSize: '12px'}}>
        {POSActive ?
          <FormattedMessage id='reports.summary.pos.active'
          values={{
            date: moment(dealer.CurrentPOSIntegrationTime).format(dateTimeFormats.monthDateTime) || moment().format(dateTimeFormats.monthDateTime),
            monthNumber: dealer.CurrentPOSIntegration === POSIntegrations.rb ? POSMonths.rb : POSMonths.evosus,
            months: <FormattedMessage id="general.months.lowercase" />,
          }}/> :
          <FormattedMessage id="reports.summary.pos.noactive"/>}
      </div>
    </div>
  );
};

summarySectionPosDate.propTypes = {
  POSActive: PropTypes.any.isRequired,
  dealer: PropTypes.object,
};

export default summarySectionPosDate;
